import { getImageProps } from "next/image"

/**
 * An optimized URL for a `<video poster>`.
 *
 * `poster` takes a single URL and no srcset, so a raw CMS/Blob poster ships
 * the original file (the testimonial stills are 70–140 KB JPEGs) to every
 * screen. This returns next/image's 2x candidate for the card's widest CSS
 * size instead: AVIF/WebP, sized for a retina card. When the card's
 * `<Image>` placeholder picks the same candidate, the poster comes from cache.
 */
export function videoPosterUrl(
  src: string,
  width: number,
  height: number
): string {
  return getImageProps({ src, alt: "", width, height }).props.src
}
